export default __webpack_public_path__ + "static/media/img_14.3555e067.jpg";